var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNewspaper(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.56 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.87 4.79h-5.24V.69a.69.69 0 00-.69-.69H.69A.69.69 0 000 .69v17.86A3.46 3.46 0 003.45 22h16.66a3.45 3.45 0 003.45-3.45V5.48a.69.69 0 00-.69-.69zM3.45 20.62a2.07 2.07 0 01-2.07-2.07V1.38h14.87v17.49a3.43 3.43 0 00.68 1.75zm18.73-2.07a2.07 2.07 0 01-2.07 2.07h-.41a2.07 2.07 0 01-2.07-2.07V6.17h4.55z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 3.31H3.68a.69.69 0 000 1.38H14a.69.69 0 000-1.38zM14 6.26H3.68a.69.69 0 000 1.38H14a.69.69 0 000-1.38zM14 17.31H3.68a.69.69 0 000 1.38H14a.69.69 0 100-1.38zM14 9.21H8.84a.69.69 0 00-.69.69v5.15a.69.69 0 00.69.69H14a.69.69 0 00.69-.69V9.9a.69.69 0 00-.69-.69zm-.69 5.15H9.53v-3.77h3.77zM3.68 11.69h2.21a.69.69 0 000-1.38H3.68a.69.69 0 000 1.38zM3.68 14.64h2.21a.69.69 0 100-1.38H3.68a.69.69 0 000 1.38z"
  })));
}

export default SvgNewspaper;